var map = {
	"./1_8_Delete.svg": "980f",
	"./43268E36B6E04671.png": "3246",
	"./66C43DCD2E51D795.png": "ca05",
	"./6A6DB9F8E7CD9279.jpg": "6893",
	"./6A6DB9F8E7CD927C.jpg": "50ad",
	"./6A6DB9F8E7CD927E.jpg": "ac91",
	"./6A6DB9F8E7CD927F.jpg": "0770",
	"./7F8A7C554C83A2C1.png": "583f",
	"./F4CDAF0B62892C30.jpg": "5fc8",
	"./F4CDAF0B62892C33.jpg": "af0b",
	"./Link-20.svg": "80ad",
	"./Minnie (45).pdf": "6e29",
	"./account_icon.svg": "4226",
	"./add-item-button.svg": "4841",
	"./alignment/align-left-new.ai": "e9e9",
	"./alignment/align-left.ai": "2a5e",
	"./analytics.svg": "732d",
	"./arrow_backward_circle.svg": "b7e1",
	"./arrow_black.svg": "370e",
	"./arrow_black_long.svg": "7f60",
	"./arrow_black_long_v2.svg": "9e6a",
	"./arrow_forward_black.svg": "24c1",
	"./arrow_forward_circle.svg": "c3ae",
	"./arrow_gray.svg": "ac8f",
	"./arrow_white.svg": "3b7e",
	"./arrow_white_2.svg": "77df",
	"./banner-overlay-less-opacity.svg": "4e51",
	"./banner-overlay.svg": "6964",
	"./bell.svg": "ee6b",
	"./bell_black.svg": "b93c",
	"./bell_dynamic_colour.svg": "c629",
	"./camera.svg": "0b86",
	"./camera_hide.svg": "ed5e",
	"./camera_show.svg": "627b",
	"./cat_header.svg": "b04d",
	"./check-mark-white.svg": "4b97",
	"./check-mark.svg": "57ad",
	"./check_mark_white.svg": "7cc7",
	"./checkmark_normal.svg": "7352",
	"./checkout/dropdown-arrow.ai": "8e03",
	"./checkout/dropdown-arrow.svg": "4dbc",
	"./close.svg": "bf37",
	"./close_gray.svg": "b701",
	"./close_new.svg": "ee35",
	"./close_search.svg": "0f14",
	"./closedialogue.svg": "a19e",
	"./color-picker.ai": "87b8",
	"./color-picker.svg": "383c",
	"./colour-palette-button.svg": "70b4",
	"./csv_icon.svg": "a6e1",
	"./dashboard.svg": "57a8",
	"./dashboard_blue.svg": "174f",
	"./delete-button.svg": "6fcf",
	"./delete_image.svg": "c867",
	"./drag-handle.svg": "adf6",
	"./duplicate-button.svg": "d597",
	"./duplicate.svg": "8c42",
	"./edit-button-new.svg": "685a",
	"./edit-item-button.svg": "de9b",
	"./edit-item.svg": "076d",
	"./expired.svg": "1eb0",
	"./features/6664DEEFE2057B50.jpg": "4633",
	"./features/6664DEEFE2057B51.jpg": "500f",
	"./features/6664DEEFE2057B52.jpg": "21e1",
	"./features/6664DEEFE2057B53.jpg": "1369",
	"./features/6664DEEFE2057B54.jpg": "ffda",
	"./features/6664DEEFE2057B55.jpg": "f789",
	"./features/6664DEEFE2057B57.jpg": "d278",
	"./features/6664DEEFE2057B5E.jpg": "57c2",
	"./features/6664DEEFE2057B5F.jpg": "16c6",
	"./features/AA6007B2DAE9B5E2.jpg": "64c2",
	"./features/AA6007B2DAE9B5E3.jpg": "571d",
	"./features/AA6007B2DAE9B5E4.jpg": "ae33",
	"./features/AA6007B2DAE9B5E5.jpg": "14c2",
	"./features/AA6007B2DAE9B5E6.jpg": "90ae",
	"./features/AA6007B2DAE9B5FD.jpg": "4579",
	"./features/AA6007B2DAE9B5FE.jpg": "688c",
	"./features/B860E0BC0BA3555.jpg": "8234",
	"./features/B860E0BC0BA3556.jpg": "09ed",
	"./features/B860E0BC0BA3557.jpg": "2235",
	"./features/B860E0BC0BA3559.jpg": "7ca9",
	"./features/B860E0BC0BA355A.jpg": "5344",
	"./features/B860E0BC0BA355B.jpg": "e807",
	"./features/B860E0BC0BA355E.jpg": "9275",
	"./features/B860E0BC0BA355F.jpg": "6ec8",
	"./features/B860E0BC0BA3569.jpg": "fbf9",
	"./features/CC9438ABAACAD2E5.jpg": "825f",
	"./features/CC9438ABAACAD2E7.jpg": "a45c",
	"./features/CC9438ABAACAD2EB.jpg": "3f8c5",
	"./features/CC9438ABAACAD2ED.jpg": "5079",
	"./features/CC9438ABAACAD2EF.jpg": "3ef5",
	"./features/CC9438ABAACAD2FA.jpg": "11c4",
	"./features/CC9438ABAACAD2FB.jpg": "233c",
	"./features/illlo_4.ai": "3c0dc",
	"./features/illlo_4.svg": "1cc2",
	"./features/illo_1.ai": "164e",
	"./features/illo_1.svg": "df87",
	"./features/illo_2.ai": "5ecb",
	"./features/illo_2.svg": "590c",
	"./features/illo_3.ai": "084f",
	"./features/illo_3.svg": "986a",
	"./features/illo_4.svg": "8221",
	"./features/illo_5.ai": "f333",
	"./features/illo_5.svg": "a5dc",
	"./first_item.svg": "e786",
	"./font_icon.svg": "52a7",
	"./fonts-button.svg": "b23d",
	"./food_drink.svg": "556d",
	"./garbage_icon.svg": "ae93",
	"./golf_bag.svg": "af15",
	"./gplay.jpg": "53f3",
	"./hole_number.svg": "76d3",
	"./homepage/90BF486898ED4D84.png": "e67a",
	"./homepage/90BF486898ED4D85.png": "101d",
	"./homepage/AC1C6D93047DFE12.png": "a808",
	"./homepage/AC1C6D93047DFE16.png": "8b24",
	"./homepage/arrow-back.svg": "f632",
	"./homepage/arrow.svg": "3bb7",
	"./homepage/contact_icon.ai": "7d7f",
	"./homepage/contact_icon.svg": "cd43",
	"./homepage/dashboard_mymenus.svg": "fbb1",
	"./homepage/dashboard_myorders.svg": "aee7",
	"./homepage/email_icon.svg": "f1a2",
	"./homepage/facebook.svg": "8fd8",
	"./homepage/hilton_logo.png": "f33e",
	"./homepage/hilton_qr_menu.png": "3d92",
	"./homepage/homepage_banner_outlined_2.ai": "a5e1",
	"./homepage/homepage_banner_outlined_2.svg": "cfba",
	"./homepage/homepage_banner_outlined_2_extended.ai": "d534",
	"./homepage/homepage_banner_outlined_2_extended.svg": "fb4d",
	"./homepage/illo_menu_create.png": "a264",
	"./homepage/illo_menu_send.png": "aa51",
	"./homepage/instagram.svg": "b63c",
	"./homepage/logos/boardwalk.png": "2fd2",
	"./homepage/logos/cafedelmor.jpg": "1a03",
	"./homepage/logos/cafedelmor.png": "3711",
	"./homepage/logos/campagnia.png": "611f",
	"./homepage/logos/chocolatebar.png": "46d8",
	"./homepage/logos/edge.png": "2b03",
	"./homepage/logos/hilton.png": "ac51",
	"./homepage/logos/kantina.jpg": "9e3d",
	"./homepage/logos/kantina.png": "ca17",
	"./homepage/logos/kayumanis.png": "26ef",
	"./homepage/logos/mamalous.jpg": "55cd",
	"./homepage/logos/mamalous.png": "e54e",
	"./homepage/logos/mireio.png": "58dc",
	"./homepage/logos/mumtaz.png": "2125",
	"./homepage/logos/palace.jpg": "5ffd",
	"./homepage/logos/palace.png": "d8af",
	"./homepage/logos/shire.jpg": "b4f0",
	"./homepage/logos/shire.png": "3100",
	"./homepage/logos/silversands.png": "6b40",
	"./homepage/logos/woodlands.png": "b707",
	"./homepage/mamalous_logo.png": "3e6a",
	"./homepage/mamalous_qr_menu.png": "f9f4",
	"./homepage/menu_create.svg": "51ca",
	"./homepage/menu_create_icon_only.png": "8a08",
	"./homepage/menu_create_icon_only.svg": "078d",
	"./homepage/menu_send.png": "36a1",
	"./homepage/menubuilder.ai": "1b2e",
	"./homepage/menubuilder.svg": "c1b2",
	"./homepage/menubuilder2.ai": "7d57",
	"./homepage/menubuilder2.svg": "f39c",
	"./homepage/menulingua_logo_v2-01.svg": "c4dc",
	"./homepage/menulingua_logomark_v2-02.svg": "0a2e",
	"./homepage/pattern_withoutbackgr-dark.png": "9ac0",
	"./homepage/pattern_withoutbackgr-dark_resized.png": "71d9",
	"./homepage/quotes.svg": "99c5",
	"./homepage/quotes_white.svg": "ea10",
	"./homepage/sign-in-icon.svg": "475f",
	"./homepage/telegram-logo.svg": "2a2c",
	"./homepage/whatsapp.svg": "38ed",
	"./homepage/x_mark_white.svg": "0bc8",
	"./icon_language.svg": "cb72",
	"./icon_recipient.svg": "8e1a",
	"./illo_chefcry.svg": "31a2",
	"./image-button.svg": "b2df",
	"./invisible-button.svg": "1f34",
	"./item-options-button.svg": "8339",
	"./language_icon_v2.ai": "6e17",
	"./language_icon_v2.svg": "6b41",
	"./language_icon_v3.svg": "a172",
	"./link-button.svg": "43d2",
	"./loading_gif.gif": "d2e1",
	"./location.svg": "a1fb",
	"./logo.png": "cf05",
	"./logo/menulingua_logo_v2.svg": "9af2",
	"./logo/menulingua_logo_v2_icon_only.svg": "3356",
	"./logo/menulingua_logo_v2_white.svg": "4a7f",
	"./maj_cat_header.svg": "6b4e",
	"./menu-settings-button.svg": "9fae",
	"./menulingua_logo_final.png": "fd96",
	"./menulingua_logo_final.svg": "c597",
	"./menulingua_logo_final_small.png": "c8fd",
	"./menus-black-new.svg": "4060",
	"./menus-black.svg": "f393",
	"./menus-blue-new.svg": "3374",
	"./menus-blue.svg": "6a59",
	"./minus.svg": "e9b2",
	"./minus_button.svg": "403f",
	"./modifiers-button.svg": "a0cb",
	"./modifiers.svg": "42bf",
	"./modifiers_icon.svg": "4175",
	"./modifiers_icon_gray.svg": "623a",
	"./more-button.svg": "304a",
	"./new-update-icon.svg": "5037",
	"./new_phone.svg": "86cb",
	"./note_icon.svg": "6603",
	"./order_plate.svg": "6c43",
	"./order_plate_black.svg": "4c7f",
	"./orders/5B15FE67D50DA4AB.jpg": "3265",
	"./orders/66AC63C1803A2A63.jpg": "0de6",
	"./orders/analytics.svg": "5094",
	"./orders/arrow_backward_black.svg": "2347",
	"./orders/arrow_forward.svg": "d42e",
	"./orders/arrow_forward_black.svg": "cd91",
	"./orders/arrow_forward_wide.svg": "10a6",
	"./orders/back_arrow_blue.ai": "43f1",
	"./orders/back_arrow_blue.svg": "c3d7",
	"./orders/banner-overlay.svg": "7a99",
	"./orders/bell_black.svg": "0aeb",
	"./orders/check_mark_white.svg": "bde0",
	"./orders/close_new.svg": "6753",
	"./orders/garbage_icon.svg": "da0f",
	"./orders/gplay.jpg": "fb3f",
	"./orders/hidden.svg": "e6a1",
	"./orders/icon_recipient.svg": "9ffc",
	"./orders/inapp.jpg": "55bb",
	"./orders/language_icon.svg": "516c",
	"./orders/license.jpg": "73bf",
	"./orders/license_screen.jpg": "82fb",
	"./orders/location.svg": "acaf6",
	"./orders/logo.png": "c7fd",
	"./orders/menulingua_logo_final.svg": "389e",
	"./orders/new-banner-overlay.svg": "c628",
	"./orders/note_icon.svg": "1a88",
	"./orders/order_plate_black.svg": "a418",
	"./orders/order_plate_blue.svg": "e54c",
	"./orders/order_session_icon.svg": "bcf9",
	"./orders/order_session_icon_gray.svg": "4fe6",
	"./orders/order_session_icon_green.svg": "98fc",
	"./orders/pax.svg": "70c0",
	"./orders/pax_black.svg": "743d",
	"./orders/phone_new.svg": "d081",
	"./orders/printspooler.jpg": "39ca",
	"./orders/rawbt.jpg": "9f8c",
	"./orders/room_number.svg": "423d",
	"./orders/slow-spring-board.mp3": "a42f",
	"./orders/table.svg": "f1e4",
	"./orders/table_black.svg": "d3f2",
	"./orders/table_black_v2.svg": "9510",
	"./orders/table_blue.svg": "a5d2",
	"./orders/table_gray.svg": "8c50",
	"./orders/table_light_orange.svg": "3104",
	"./orders/table_orange.svg": "6646",
	"./orders/to-the-point.mp3": "998b",
	"./orders/visible.svg": "20cc",
	"./orders/x_button.svg": "26b3",
	"./pagination/paginate_arrow.ai": "fae3",
	"./pagination/paginate_arrow.svg": "36f3",
	"./pagination/paginate_arrow_small.ai": "bcf0",
	"./pax.svg": "e51a",
	"./pdf_icon.svg": "dd99",
	"./phone_new.svg": "33c8",
	"./plus_button.svg": "a7d4",
	"./qr_icon.svg": "95f6",
	"./restaurant.svg": "5d27",
	"./room_number.svg": "b4b5",
	"./save.svg": "dacc",
	"./scroll.svg": "d4cd",
	"./search.svg": "51f2",
	"./settings.svg": "e9b0",
	"./sign-out-icon.svg": "6e21",
	"./spa.svg": "86b9",
	"./stroke_weight.svg": "fd00",
	"./table.svg": "ac65",
	"./tag_icons/alcohol.svg": "d1a7",
	"./tag_icons/alcohol_free.svg": "d592",
	"./tag_icons/celery.svg": "830d",
	"./tag_icons/chef_recommended.svg": "fe15",
	"./tag_icons/clams.svg": "5799",
	"./tag_icons/dairy.svg": "9ac5",
	"./tag_icons/dairy_free.svg": "16d4",
	"./tag_icons/egg.svg": "1e5f",
	"./tag_icons/fish.svg": "dcc2",
	"./tag_icons/gluten.svg": "83e2",
	"./tag_icons/gluten_free.svg": "53ff",
	"./tag_icons/halal.svg": "fffb",
	"./tag_icons/lupin.svg": "3f64",
	"./tag_icons/mustard.svg": "aba4",
	"./tag_icons/peanuts.svg": "663b",
	"./tag_icons/pork.svg": "6501",
	"./tag_icons/sesame.svg": "ba11",
	"./tag_icons/sesame_seeds.svg": "7569",
	"./tag_icons/shellfish.svg": "d488",
	"./tag_icons/soy_beans.svg": "7963",
	"./tag_icons/spicy.svg": "08d3",
	"./tag_icons/spicy_level_three.svg": "3766",
	"./tag_icons/spicy_level_two.svg": "438f",
	"./tag_icons/sulfites.svg": "f4f4",
	"./tag_icons/sustainable_fishing.svg": "933e",
	"./tag_icons/twenty_four_hours.svg": "418c",
	"./tag_icons/vegan.svg": "82e7",
	"./tag_icons/vegetarian.svg": "048d",
	"./tag_icons/walnuts.svg": "043b",
	"./three_dots.svg": "dbfe",
	"./update-icon-01.svg": "5760",
	"./update-icon.svg": "9df9",
	"./update.svg": "8124",
	"./visible-button.svg": "e385",
	"./white_check_mark.svg": "5c2f",
	"./x-black.svg": "0814"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";